import { cn } from "@/lib/utils";

interface CommentDotProps {
  positionX: number;
  positionY: number;
  isHighlighted?: boolean;
  isPending?: boolean;
  onClick?: () => void;
}

const CommentDot = ({
  positionX,
  positionY,
  isHighlighted = false,
  isPending = false,
  onClick,
}: CommentDotProps) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className={cn(
        "absolute w-5 h-5 rounded-full -translate-x-1/2 -translate-y-1/2 transition-all duration-200 z-10",
        "border-2 border-acid-green",
        isPending
          ? "bg-acid-green/60 cursor-default shadow-lg"
          : "bg-acid-green/80 cursor-pointer hover:scale-110 shadow-[0_0_12px_rgba(205,255,0,0.5)]",
        isHighlighted && "ring-4 ring-acid-green/40 scale-125"
      )}
      style={{
        left: `${positionX}%`,
        top: `${positionY}%`,
      }}
      aria-label={isPending ? "New comment location" : "View comment"}
    />
  );
};

export default CommentDot;
